// extracted by mini-css-extract-plugin
export default {"error":"Error_error__Kn8eX","link":"Error_link__kb17I"};